import { render } from "./distpatchTable.vue?vue&type=template&id=19860bfc&scoped=true"
import script from "./distpatchTable.vue?vue&type=script&lang=js"
export * from "./distpatchTable.vue?vue&type=script&lang=js"

import "./distpatchTable.vue?vue&type=style&index=0&id=19860bfc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19860bfc"]])

export default __exports__